<div class="border border-[#DDDDDE] rounded-lg flex-col px-2 max-w-[500px]">
  <div class="flex justify-between border-b border-[#DDDDDE] py-1">
    <span class="text-sm text-neutral-[#1C1D22]"
      >Real Property Amount Total</span
    >
    <span class="text-neutral-900 font-light">{{
      data().realTotal | currency
    }}</span>
  </div>
  <div class="flex justify-between border-b border-[#DDDDDE] py-1">
    <span class="text-sm text-neutral-[#1C1D22]"
      >Personal Property Amount Total</span
    >
    <span class="text-neutral-900 font-light">{{
      data().personalTotal | currency
    }}</span>
  </div>
  <div class="flex justify-between py-1">
    <span class="text-sm text-neutral-[#1C1D22]">Total Amount</span>
    <span class="text-neutral-900 font-light">{{
      data().estateTotal | currency
    }}</span>
  </div>
</div>
